import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getVendas = async (params?: { dataInicio?: string; dataFim?: string }) => {
  const query = new URLSearchParams();
  if (params?.dataInicio) query.append("dataInicio", params.dataInicio);
  if (params?.dataFim) query.append("dataFim", params.dataFim);
  const queryString = query.toString();
  return requestApi.get(`${API_CONSTANT_MAP.venda}${queryString ? `?${queryString}` : ""}`);
};

export const getVendaById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.venda}/${id}`);
};

export const saveVenda = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.venda, payload);
};
